// extracted by mini-css-extract-plugin
module.exports = {"confirmDialog":"_confirmDialog--5iB_3","accessibilityAlert":"_accessibilityAlert--2w1Aq","content":"_content--pIkTp","spin":"_spin--2qvNf","progressDots":"_progressDots--2pa5I"};